/**
 * Link-out integration (deep link → Add Request → api/linkout/submit).
 *
 * Set to `false` to disable all related UI, guards, and API usage without removing files.
 * To remove the feature permanently later: search the codebase for `LINKOUT_FEATURE_ENABLED`
 * and delete the guarded blocks / linkout module route.
 */
export const LINKOUT_FEATURE_ENABLED = true;
